import React from 'react';
import '../screens/InvitationListScreen.css'; // Reusing the existing CSS
import {
  ATTENDING_ICON,
  NOT_ATTENDING_ICON,
  MAYBE_ICON,
  MIXED_ICON,
  VIEWED_ICON,
  NOT_VIEWED_ICON,
  DIETARY_ICON,
  TRANSPORTATION_ICON,
  TEENAGER_ICON,
  CHILD_ICON,
  BABY_ICON
} from '../utils/iconUtils';

/**
 * Component that displays status totals for invitations and guests
 * @param {Object} totals - Object containing invitation and guest status totals
 */
function StatusTotals({ totals }) {
  return (
    <div className="status-totals">
      <h3>Status Totals</h3>
      <div className="totals-container">
        <div className="totals-column">
          <h4>Invitations</h4>
          <div className="totals-item">
            <span className="symbol">{ATTENDING_ICON}</span>
            <span className="label">Attending: </span>
            <span className="count">{totals.invitations.ATTENDING}</span>
          </div>
          <div className="totals-item">
            <span className="symbol">{NOT_ATTENDING_ICON}</span>
            <span className="label">Not Attending: </span>
            <span className="count">{totals.invitations.NOT_ATTENDING}</span>
          </div>
          <div className="totals-item">
            <span className="symbol">{MAYBE_ICON}</span>
            <span className="label">Maybe: </span>
            <span className="count">{totals.invitations.MAYBE}</span>
          </div>
          <div className="totals-item">
            <span className="symbol">{MIXED_ICON}</span>
            <span className="label">Mixed: </span>
            <span className="count">{totals.invitations.MIXED}</span>
          </div>
          <div className="totals-item">
            <span className="symbol">{VIEWED_ICON}</span>
            <span className="label">Viewed: </span>
            <span className="count">{totals.invitations.VIEWED}</span>
          </div>
          <div className="totals-item">
            <span className="symbol">{NOT_VIEWED_ICON}</span>
            <span className="label">Not Viewed: </span>
            <span className="count">{totals.invitations.NOT_VIEWED}</span>
          </div>
        </div>
        <div className="totals-column">
          <h4>Guests</h4>
          <div className="totals-item">
            <span className="symbol">{ATTENDING_ICON}</span>
            <span className="label">Attending: </span>
            <span className="count">{totals.guests.ATTENDING}</span>
          </div>
          <div className="totals-item">
            <span className="symbol">{NOT_ATTENDING_ICON}</span>
            <span className="label">Not Attending: </span>
            <span className="count">{totals.guests.NOT_ATTENDING}</span>
          </div>
          <div className="totals-item">
            <span className="symbol">{MAYBE_ICON}</span>
            <span className="label">Maybe: </span>
            <span className="count">{totals.guests.MAYBE}</span>
          </div>
          <div className="totals-item">
            <span className="symbol">{VIEWED_ICON}</span>
            <span className="label">Viewed: </span>
            <span className="count">{totals.guests.VIEWED}</span>
          </div>
          <div className="totals-item">
            <span className="symbol">{NOT_VIEWED_ICON}</span>
            <span className="label">Not Viewed: </span>
            <span className="count">{totals.guests.NOT_VIEWED}</span>
          </div>
          <div className="totals-item">
            <span className="symbol">{DIETARY_ICON}</span>
            <span className="label">Dietary Requirements*: </span>
            <span className="count">{totals.guests.DIETARY}</span>
          </div>
          <div className="totals-item">
            <span className="symbol">{TRANSPORTATION_ICON}</span>
            <span className="label">Transportation*: </span>
            <span className="count">{totals.guests.TRANSPORTATION}</span>
          </div>
        </div>
        {totals.ages && (
          <div className="totals-column">
            <h4>Age Categories*</h4>
            <div className="totals-item">
              <span className="symbol">👤</span>
              <span className="label">Adult: </span>
              <span className="count">{totals.ages.Adult}</span>
            </div>
            <div className="totals-item">
              <span className="symbol">{TEENAGER_ICON}</span>
              <span className="label">Teenager: </span>
              <span className="count">{totals.ages.Teenager}</span>
            </div>
            <div className="totals-item">
              <span className="symbol">{CHILD_ICON}</span>
              <span className="label">Child: </span>
              <span className="count">{totals.ages.Child}</span>
            </div>
            <div className="totals-item">
              <span className="symbol">{BABY_ICON}</span>
              <span className="label">Baby: </span>
              <span className="count">{totals.ages.Baby}</span>
            </div>
          </div>
        )}
      </div>
      <div className="totals-footnote">
        <small>* Attending guests only</small>
      </div>
    </div>
  );
}

export default StatusTotals;
